import React, { useEffect, useMemo, useState } from "react";
import { cloneDeep } from "lodash";
import { Form, Row, Col, FormGroup, Label, Input, Card } from "reactstrap";
import NodeNameValidation from "../../atoms/node-name-validation";
import InsertSelector from "../insert-selector";
import HelpTooltip from "../../atoms/help-tooltip";
import { t } from "../../../utils/utils";
import T from "../../atoms/translate";
export default function NodeInsertProperty({ node, nodeChange, dependencies }) {
  const models = useMemo(() => dependencies.getModels().models, [dependencies]);
  const [values, setValues] = useState([]);
  const [model, setModel] = useState("");
  const [inputData, setInputData] = useState({});
  const changeSelect = ({ target }, setter) => {
    const values = [].filter
      .call(target.options, o => o.selected)
      .map(o => o.value);
    setter(values[0]);
  };
  useEffect(() => {
    const { args } = node.properties;
    if (args) {
      if (args.inputData) {
        setInputData(args.inputData);
      }
      if (args.insertAction) {
        setModel(args.insertAction.model);
        setValues(
          Object.entries(args.insertAction.values[0]).map(([key, o]) => ({
            field: key,
            value: o
          }))
        );
      }
    }
  }, [node]);
  const onSubmit = name => {
    const tmp = cloneDeep(node);
    tmp.properties.name = name;
    const { args } = tmp.properties;
    if (inputData) {
      args.inputData = inputData;
    }
    if (model) {
      args.insertAction = {
        model: model,
        values: [Object.fromEntries(values.map(o => [o.field, o.value]))]
      };
    }
    nodeChange(tmp);
  };
  return (
    <>
      <NodeNameValidation
        label={t("modalPropiedadesLabelNodoValidacionNombre")}
        feedback={t("modalPropiedadesFeedbackValidacionNombre")}
        nodesNames={dependencies.nodeNames}
        oldName={node.properties.name}
        onSubmit={onSubmit}
      />
      <Card body className="border-0 box-shadow mb-4">
        <Row>
          <Col xs="12">
            <h1 className="font-size-09 text-secondary fw-600 text-uppercase">
              <T i18nKey="modalPropiedadesInsertarTitulo" />
            </h1>
          </Col>
          <Col xs="12">
            <Form>
              <Row form>
                <Col md={4}>
                  <FormGroup>
                    <Label>
                      <T i18nKey="modelo" />{" "}
                      <HelpTooltip msg={t("modalPropiedadesInsertarTooltip")} />
                    </Label>
                    <Input
                      type="select"
                      value={model}
                      onChange={e => changeSelect(e, setModel)}
                    >
                      <option value="" />
                      {models.map((o, key) => (
                        <option key={key}>{o.name}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Card>

      <InsertSelector
        fields={model ? models.find(o => o.name === model).attributes : []}
        values={values}
        setInputData={setInputData}
        inputData={inputData}
        context={dependencies.context}
        setValues={setValues}
      />
    </>
  );
}
